export const privilege = {
    topbar_title: 'สิทธิพิเศษ',
}
